import * as Auth             from '../auth';
import * as Business         from '../business';
import * as User             from '../user';
import { connect }           from 'react-redux';
import classnames            from 'classnames';
import FetchFromServer       from '../components/fetch_from_server';
import React                 from 'react';
import withMainRouteParams   from '../components/with_main_route_params';
import WithoutPaddingInViews from '../components/without_padding_in_views';


class ImpersonateBar extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      canImpersonate:  false,
      isImpersonating: false
    };
  }

  static getDerivedStateFromProps({ isSalesforce, users, logged, businessID }) {
    const hasBusiness     = !!businessID;
    const canImpersonate  = hasBusiness && isSalesforce;
    const isImpersonating = canImpersonate && users?.some(user => user.id === logged.userID);

    return {
      canImpersonate,
      isImpersonating
    };
  }

  render() {
    const { canImpersonate } = this.state;
    if (!canImpersonate)
      return null;

    const { load }            = this.props;
    const { logged }          = this.props;
    const { statuses }        = this.props;
    const { users }           = this.props;
    const { isImpersonating } = this.state;
    const className           = classnames(
      'impersonate__bar row no-gap align-items-center',
      { 'impersonate__bar--highlight': isImpersonating }
    );

    return (
      <div className="impersonate">
        <WithoutPaddingInViews className={className}>
          <FetchFromServer statuses={statuses} load={load} pullToRefresh={false}>
            <div className="col signedin">Signed in as: {logged.name}</div>
            <div className="col text-align-right">
              {users && <SignInAs selected={logged.userID} users={users}/>}
            </div>
          </FetchFromServer>
        </WithoutPaddingInViews>
      </div>
    );
  }
}


function SignInAs({ users, selected }) {
  return (
    <label className="form__select no-fastclick">
      Sign in as:
      <div className="form__select__container read-write">
        <select onChange={handleChange} defaultValue={selected}>
          <option value="">Broadly Support</option>
          {users.map(user => (
            <option key={user.id} value={user.id}>
              {user.name}
            </option>
          )
          )}
        </select>
      </div>
    </label>
  );
}


function handleChange(event) {
  event.preventDefault();
  const userID = event.target.value || null;
  Auth.authenticateWithOAuth('salesforce', userID);
}


export default withMainRouteParams(
  connect(
    (state, { businessID }) => ({
      isSalesforce: User.isSalesforce(state),
      users:        Business.getUsers(state, businessID),
      statuses:     Business.getBusinessStatuses(state, businessID),
      logged:       User.getProfile(state)
    }),
    (dispatch, { businessID }) => ({
      load: () => dispatch(Business.loadBusiness(businessID))
    })
  )(ImpersonateBar)
);
